export default function Button({
  disabled,
  onClick,
  text,
  backgroundColor,
  hoverBgColor,
  type,
  className,
}) {
  const defaultClassName = `px-12 py-3 bg-${backgroundColor} text-white capitalize flex text-xs items-center hover:${hoverBgColor} rounded-lg`;
  const applyClassName = className ? className : defaultClassName;
  return (
    <button
      disabled={disabled}
      type={type}
      className={applyClassName}
      onClick={onClick}
    >
      {text}
    </button>
  );
}
